<template>
  <div class="mh-grid-action-btns">
    <b-button
      class="mh-grid-action-btn"
      @click="editItem()"
      variant="default btn-sm"
    >
      <font-awesome-icon :icon="['fas', 'pen']" class="icon alt" />
    </b-button>
    <b-button
      v-if="xprops.allowDelete === true && (row.isStatic == null || row.isStatic === false)" 
      @click="removeItem(row.id)"
      class="mh-grid-action-btn mh-delete"
      variant="default btn-sm danger"
    >
      <font-awesome-icon :icon="['fas', 'trash']" class="icon alt" />
    </b-button>
  </div>
</template>
<script>
export default {
  props: ['row', 'xprops'],
  mounted() {},
  methods: {
    removeItem: function(id) {
      var self = this
      this.$swal({
        title: 'Varování',
        text: 'Opravdu chcete položku odebrat?',
        type: 'warning',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
        buttons: ['Zrušit', 'Potrvdit smazání'],
      })
        .then((willDelete) => {
          if (willDelete) {
            self.xprops.eventbus.$emit('DELETE_ITEM', { id: id })
          }
        })
        .catch(this.$swal.noop)
    },
    editItem: function() {
      // pokud je vyplnena editRouteName provede presmerovani, pokud ne vyvola udalost EDIT_ITEM
      if (
        this.xprops.editRouteName === '' ||
        this.xprops.editRouteName === undefined
      ) {
        this.xprops.eventbus.$emit('EDIT_ITEM', { row: this.row })
      } else {
        this.$router.push({
          name: this.xprops.editRouteName,
          params: { id: this.row.id },
        })
      }
    },
  },
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}

.mh-grid-action-btn {
  margin-top: -15px;
}

.mh-grid-action-btn.mh-delete {
  margin-left: 5px;
  color: #e44d4d;
}
</style>
